import { render } from "./MachineHeader.vue?vue&type=template&id=64816cb8&scoped=true"
import script from "./MachineHeader.vue?vue&type=script&lang=js"
export * from "./MachineHeader.vue?vue&type=script&lang=js"

import "./MachineHeader.vue?vue&type=style&index=0&id=64816cb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64816cb8"]])

export default __exports__